var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('a',{attrs:{"href":"/"}},[_vm._v("USE OF COOKIES")])])
}]

export { render, staticRenderFns }